import client from "@/lib/api";

// Module-level cache for the current user's invite payload (code, url, image_url,
// share_text). Prefetched once at app load so the Invite dialog's card image + links
// are ready before it opens. Warming the invite card URL also primes any CDN/proxy
// cache for the preview image.
let _cache = null;
let _promise = null;

export function getInviteCache() {
  return _cache;
}

export function prefetchInvite() {
  if (_cache) return Promise.resolve(_cache);
  if (_promise) return _promise;
  _promise = client
    .get("/me/invite")
    .then((r) => {
      _cache = r.data || null;
      _promise = null;
      // Warm the preview card image so it's decoded/cached before the dialog opens.
      if (_cache?.image_url && typeof Image !== "undefined") {
        try { new Image().src = _cache.image_url; } catch { /* ignore */ }
      }
      return _cache;
    })
    .catch(() => {
      _promise = null;
      return null;
    });
  return _promise;
}
